<style scoped>
a {
  position: relative;
}

img {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
  cursor: pointer;
}

svg {
  position: absolute;
  width: 80px;
  height: 80px;
  left: 50%;
  top: 50%;
  margin: -40px;
  pointer-events: none;
}

.length {
  position: absolute;
  background: #B4C3B9;
  color: #fff !important;
  padding: 3px 6px;
  line-height: 1;
  right: 0;
  bottom: 0;
}
</style>


<script>
import VideoThumbnail from "./VideoThumbnail.vue";

export default {
  props: ["videoUrl", "fallbackImage", "duration"]
};
</script>

<template>
  <video-thumbnail :video-url="videoUrl" :fallback-image="fallbackImage" v-slot="videoThumbnailProps">
    <a>
      <img :src="videoThumbnailProps.src" />

      <svg aria-hidden="true" focusable="false" data-prefix="fad" data-icon="play-circle" role="img"
        xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
        <g class="fa-group">
          <path fill="black"
            d="M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm115.7 272l-176 101c-15.8 8.8-35.7-2.5-35.7-21V152c0-18.4 19.8-29.8 35.7-21l176 107c16.4 9.2 16.4 32.9 0 42z"
            opacity="0.4" />
          <path fill="white"
            d="M371.7 280l-176 101c-15.8 8.8-35.7-2.5-35.7-21V152c0-18.4 19.8-29.8 35.7-21l176 107c16.4 9.2 16.4 32.9 0 42z" />
        </g>
      </svg>

      <div class="length">{{ duration }}</div>
      <div class="hover"></div>
    </a>
  </video-thumbnail>
</template>